import { type TableSettingsState, TableSettingsStateSchema } from './types'

/**
 * Validates table settings against schema and version compatibility.
 * @param tableSettings - The table settings to validate
 * @param initialTableSettings - The initial settings for version comparison
 * @returns Validated settings or null if invalid
 */
export const validateTableSettings = (
  tableSettings: TableSettingsState,
  initialTableSettings: TableSettingsState
) => {
  const result = TableSettingsStateSchema.safeParse(tableSettings)

  if (!result.success) {
    return null
  }

  const cookieVersion = result.data.version

  if (cookieVersion !== initialTableSettings.version) {
    return null
  }

  return result.data
}
